import { apiFetch } from './client';
import type { Conversation } from '../types/contracts';

export interface Project {
  id: string;
  name: string;
  description: string | null;
  created_at?: string;
  updated_at?: string;
}

export const projectsApi = {
  list: () => apiFetch<Project[]>('/api/projects'),
  get: (id: string) => apiFetch<Project>(`/api/projects/${id}`),
  create: (d: { name: string; description?: string }) =>
    apiFetch<Project>('/api/projects', { method: 'POST', body: JSON.stringify(d) }),
  update: (id: string, d: { name?: string; description?: string }) =>
    apiFetch<Project>(`/api/projects/${id}`, { method: 'PATCH', body: JSON.stringify(d) }),
  remove: (id: string) => apiFetch<void>(`/api/projects/${id}`, { method: 'DELETE' }),
  conversations: (id: string) => apiFetch<Conversation[]>(`/api/projects/${id}/conversations`),
};
